module.exports = __webpack_public_path__ + "static/media/apartment2.1fd1bbea.jpg";